<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.construction.material_management.project_part.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['project_stock'], ['read'])" title=""
                        :importable="true"
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        :otherItemsTitle="'general.buttons.procured_quantity'"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @rowClickParts="onPartsRow"
                        @rowClickCloudDownloadRow="onDownloadProjectPartsImages"
                        @rowClickOtherItems="onOtherItemsRow"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        @exportButtonClick="onExportButton"
                        >
                    </data-table>

                    <b-dropdown id="dropdown-dropbottom" dropbottom :text="$t('general.buttons.go_to.title')" variant="primary" class="mt-2 mr-2" v-if="hasIsometricPermission || hasChangeOrderPermission">
                        <b-dropdown-item-btn @click="returnToIso" v-if="hasIsometricPermission">
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.go_to.go_to_isometric')}}
                        </b-dropdown-item-btn>

                        <b-dropdown-divider></b-dropdown-divider>

                        <b-dropdown-item-btn @click="returnToChangeOrder" v-if="hasChangeOrderPermission">
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.go_to.go_to_change_orders')}}
                        </b-dropdown-item-btn>
                    </b-dropdown>

                    <b-btn class="btn btn-default mt-2 mr-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_stock'], ['create'])">
                        <i class="fa fa-plus-circle mr-1"></i> {{$t('general.construction.material_management.project_part.create_button')}}
                    </b-btn>

                    <span v-if="this.$store.getters.hasPermission(['project_stock'], ['create', 'update'])">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-primary mt-3" @click="$refs.importExcel.value = ''">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.construction.material_management.project_stock.import_button') }}</span>
                            <input type="file" name="file" style="display:none" ref="importExcel" @change="onImportButton($event.target.name, $event.target.files)" accept="application/*"/>
                        </label>
                        <label v-else class="btn btn-primary mt-3 disabled">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>
                </b-card>

                <div class="row" v-if="getData.rowData.length > 0">
                    <div class="col-sm-12">
                        <i class="fa fa-2x fa-th-list text-default"></i> - {{$t('general.construction.material_management.project_stock.part_stock')}} &nbsp; &nbsp;
                        <i class="fa fa-2x fa-bars text-secondary"></i> - {{$t('general.buttons.procured_quantity')}}
                    </div>
                </div>
            </div>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" id="saveModal" :title="actionTitle" size="lg" @ok="saveAction" @hidden="saveHidden" no-stacking :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_stock'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="5" maxlength="5000" class="form-control" v-model="model.description" :disabled="row != null"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.standard') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.standard" :disabled="row != null">
                                <option v-for="standard in part_standard" :value="standard" :key="standard">{{standard}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_material') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.material" :disabled="row != null">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_size') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.size" :disabled="row != null">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_thk') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.thk" :disabled="row != null">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_sizer') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.sizer">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_thkr') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.thkr">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_dimension') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.dimension">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.equipment != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.equipment') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.equipment" disabled>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_measureunit') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.measureunit">
                                <option v-for="measure_unit in measure_units" :value="measure_unit.code" :key="measure_unit.code">{{ measure_unit.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_unitweight') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.unitweight">
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <project-part-stock ref="projectPartStockModal" @onLoadTable="onLoadTable"></project-part-stock>
        <project-procured ref="projectProcuredModal" @onLoadTable="onLoadTable"></project-procured>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';

import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';

import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

import Multiselect from 'vue-multiselect';
import ProjectPartStock from '@/components/pages/project/construction/material_management/project_part_stock';
import ProjectProcured from '@/components/pages/project/construction/material_management/project_procured';

export default {
    name: 'project_parts',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
        ProjectPartStock,
        ProjectProcured
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.construction.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.construction.material_management.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.construction.material_management.project_part.title'),
                    active: true
                }
            ],
            tableName: 'project_part',
            tableNameTranslated: Vue.i18n.translate('general.construction.material_management.project_part.title_modal'),
            tableNameTranslatedPart: Vue.i18n.translate('general.construction.material_management.project_part.title_modal'),

            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            isLoading: false,
            delete_message: '',

            selectedPart: null,
            currentPart: [],
            isPartLoading: false,

            hasIsometricPermission: false,
            hasChangeOrderPermission: false,

            //check if already opened
            already_opened_warning: false,
            //end check if already opened

            getData: {
                rowData: [],
                getFiles: []
            },
            file: false,

            model: {
                description: null,
                number: null,
                standard: null,
                material: null,
                size: null,
                sizer: null,
                thk: null,
                thkr: null,
                dimension: null,
                equipment: null,
                total_qty: null,
                measureunit: null,
                unitweight: null,
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    field: '',
                    width: '130px',
                    showDeleteButton: true,
                    showEditButton: true,
                    showPartStockButton: true,
                    showOtherItemsButton: true,
                    showCloudDownloadButton: true,
                },
                {
                    label: Vue.i18n.translate('table.part_number'),
                    field: 'number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_description'),
                    field: 'description',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_material'),
                    field: 'material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_size'),
                    field: 'size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thk'),
                    field: 'thk',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_sizer'),
                    field: 'sizer',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thkr'),
                    field: 'thkr',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.dimension'),
                    field: 'dimension',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.equipment'),
                    field: 'equipment',
                    numeric: false,
                    html: false,
                    showItalicIfNull: true,
                },
                {
                    label: Vue.i18n.translate('table.part_measureunit'),
                    field: 'measureunitV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_unitweight'),
                    field: 'unitweight',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.procured_qty'),
                    field: 'procured_qty',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.total_qty_project'),
                    field: 'total_qty_project',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.not_procured_qty'),
                    field: 'not_procured_qty',
                    numeric: false,
                    html: true,
                },
                {
                    label: Vue.i18n.translate('table.qty_on_hold'),
                    field: 'quantity_hold',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.qty_in_stock'),
                    field: 'quantity_stock',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.qty_reserved'),
                    field: 'quantity_reserved',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.delivered_qty'),
                    field: 'quantity_delivered',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted() {
        this.onLoadTable();

        this.hasIsometricPermission   = this.$store.getters.hasPermission(['project_isometric'], ['read']);
        this.hasChangeOrderPermission = this.$store.getters.hasPermission(['project_change_orders'], ['read']);
    },
    computed: {
        part_standard: {
            get: function () {
                let standard = this.$store.getters.getPartStandard;
                return standard;
            }
        },
        measure_units: {
            get: function () {
                let measure_units = this.$store.getters.getMeasureUnits;
                return measure_units;
            }
        }
    },
    watch: {
        part_standard: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        measure_units: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        warnMsg(msg) {
            miniToastr.warn(msg, Vue.i18n.translate('messages.warn'), 5000);
        },
        returnToIso() {
            this.$router.push('/project/'+this.$route.params.id+'/isometric_management');
        },
        returnToChangeOrder() {
            this.$router.push('/project/'+this.$route.params.id+'/commercial/change_orders');
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route('project_part?project_id=' + this.$route.params.id + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach(field => {
                        if (typeof this.measure_units[field.measureunit] != 'undefined') {
                            field.measureunitV = this.measure_units[field.measureunit].name;
                        }
                    });

                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslatedPart;
            this.row = null;
            this.model.total_qty   = null;
            this.model.description = null;
            this.model.standard    = null;
            this.model.number      = null;
            this.model.material    = null;
            this.model.size        = null;
            this.model.thk         = null;
            this.model.sizer       = null;
            this.model.thkr        = null;
            this.model.dimension   = null;
            this.model.equipment   = null;
            this.model.measureunit = null;
            this.model.unitweight  = null;

            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslatedPart;
            this.row = row;

            //check if already opened
            this.already_opened_warning = false;
            let data = {
                id: this.row.id,
                object_is_opened_now: 1,
            };
            http.route(this.tableName + '/' + this.row.id).patch(data, true).then(response => {
                if (response.isError == false) {
                    if (typeof response.data != 'undefined') {
                        if (response.data.opened_by != this.$store.state.user.user.id) {
                            this.warnMsg(Vue.i18n.translate('misc.document_is_open'));
                        }
                    }
                }
            });
            //end check if already opened

            this.model.total_qty   = row.total_qty;
            this.model.description = row.description;
            this.model.standard    = row.standard;
            this.model.number      = row.number;
            this.model.material    = row.material;
            this.model.size        = row.size;
            this.model.thk         = row.thk;
            this.model.sizer       = row.sizer;
            this.model.thkr        = row.thkr;
            this.model.dimension   = row.dimension;
            this.model.equipment   = row.equipment;
            this.model.measureunit = row.measureunit;
            this.model.unitweight  = row.unitweight;

            this.$refs.saveModal.show();
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslatedPart;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                project_id:  this.$route.params.id,
                description: this.model.description,
                standard:    this.model.standard,
                number:      this.model.number,
                material:    this.model.material,
                size:        this.model.size,
                thk:         this.model.thk,
                sizer:       this.model.sizer,
                thkr:        this.model.thkr,
                dimension:   this.model.dimension,
                measureunit: this.model.measureunit,
                unitweight:  this.model.unitweight,
            };

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row != null) {
                delete put_data['description'];
                delete put_data['standard'];
                delete put_data['material'];
                delete put_data['size'];
                delete put_data['thk'];

                //check if already opened
                put_data['already_opened_warning'] = this.already_opened_warning;
                //end check if already opened

                http.route(this.tableName + '/' + this.row.id).patch(put_data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslatedPart + Vue.i18n.translate('messages.updated'));
                        this.onLoadTable();
                        this.$refs.saveModal.hide();

                        //check if already opened
                        this.already_opened_warning = false;
                        //end check if already opened
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            //check if already opened
                            if (response.errorMessage[key] == 'misc.document_already_opened') {
                                this.already_opened_warning = true;
                                this.errorMsg(Vue.i18n.translate('misc.document_already_opened'));
                            } else {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            }
                            //end check if already opened
                        });
                    }
                });
            } else {
                let data = http.route(this.tableName).post(put_data, true);
                data.then(response => {
                    if(response.isError == false) {
                        this.successMsg(this.tableNameTranslatedPart + Vue.i18n.translate('messages.created'));
                        this.onLoadTable();
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (response.isError) {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    } else {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslatedPart + Vue.i18n.translate('messages.deleted'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        saveHidden() {
            //check if already opened
            this.already_opened_warning = false;
            if (this.row != null) {
                let data = {
                    id: this.row.id,
                    object_is_opened_now: 0,
                };
                http.route(this.tableName + '/' + this.row.id).patch(data, true);
            }
            //end check if already opened
        },
        onPartsRow (row, index) {
            this.$refs.projectPartStockModal.showModal(row.id);
        },
        onOtherItemsRow (row) {
            this.$refs.projectProcuredModal.showModal(row.id);
        },
        onDownloadProjectPartsImages (row) {
            let data = http.route('project_stock?project_id=' + this.$route.params.id + '&filters[project_part_id]=' + row.id  + '&filters[not_status]=procured').get();
            data.then(response => {
                if (!response.isError) {
                    if (response.data.length > 0) {
                        response.data.forEach(field => {
                            this.$refs.projectPartStockModal.onViewFiles(field, null, true);
                        });
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.no_attachments'));
                    }
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onExportButton() {
            http.route('project_part').exportExcel({
                export: 1,
                project_id: this.$route.params.id,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'project_parts.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslatedPart + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onImportButton(fieldName, fileList) {
            const formData = new FormData();

            if (!fileList.length) return;

            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            formData.append('project_id', this.$route.params.id);

            http.route('project_part/import').importExcel(formData)
            .then(response => {
                if (response.isError) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.imported'));
                }
            });
        },
        stockModalHidden() {
            this.$refs.stockModal.show();
            this.getData.rowData = [];
            this.onLoadTable();
        },
        onPartSearch(search) {
            if (search == '') {
                this.currentPart = [];

                return false;
            }

            this.isPartLoading = true;
            this.searchPart(search, this);
        },
        searchPart: _.debounce((search, vm) => {
            let data = http.route('project_part?project_id='+ vm.$route.params.id +'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentPart = response.data;
                }
                vm.isPartLoading = false;
            });
        }, 500),
        updatePart(part) {
            this.model.project_part_id = (part != null) ? part.id : null;
        }
    }
}
</script>

<style scoped>
	select {
		-webkit-appearance:menulist-button;
		-moz-appearance:menulist-button;
	}
    .files_list:nth-child(even){
        background-color: #eee;
    }
    .files_list:nth-child(odd){
        background-color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/project/construction/material_management/project_parts.vue